import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $timeout, LocaleService, InsuranceSuiteMetadata, StateUtils, submissionViewModel) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    ctrl.init = function () {
        ctrl._setBindDataDefaultValues();
        $scope.$filter = $filter;
        $scope.startDate = new Date();
        $scope.disabled = false;

        $scope.states = InsuranceSuiteMetadata.get('pc').types.getTypelist('State').codes;
        $scope.bindData = submissionVM.bindData;
        $scope.bindData.chosenQuote.value = StateUtils.activeDataForState(true).chosenQuote;
        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
        $scope.periodStartDate = submissionVM.baseData.periodStartDate.value;
        $scope.lobData = submissionVM.lobData.value;
    };

    ctrl.isAccountHolder = function (driver) {
        return submissionVM.value.getAccountHolderPerson() === driver.person;
    };

    ctrl.lookupPerson = function (driver) {
        return _.findWhere(submissionVM.submission.persons.value, {
            publicID: driver.personID
        });
    };

    ctrl.lookupState = function (state) {
        var stateName = _.findWhere($scope.states, {
            code: state
        });
        if (!stateName) {
            // try the country
            stateName = _.findWhere(InsuranceSuiteMetadata.get('pc').types.getTypelist('Country').codes, {
                code: state
            });
        }
        return stateName;
    };

    ctrl.driverSort = function (driver) {
        if (ctrl.isAccountHolder(driver)) {
            return -1;
        }
        return driver.getDisplayName(undefined, $filter);
    };

    ctrl._setBindDataDefaultValues = function () {
        submissionVM.bindData.value = submissionVM.bindData.value || {};
        if (!submissionVM.bindData.billingAddress.value) {
            submissionVM.bindData.billingAddress.value = {};
            angular.copy(submissionVM.baseData.policyAddress.value, submissionVM.bindData.billingAddress.value);
        }
        submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
        submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value || submissionVM.baseData.accountHolder.emailAddress1.value;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'InsuranceSuiteMetadata', 'StateUtils', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/controllers/PAPolicyInfoCtrl.js
// module id = 2166
// module chunks = 0